module.exports = __webpack_public_path__ + "img/control_de_calidad_4-3_3072.c9cfb318.webp";